import request from '@/utils/request'

// ==================== 文章 ====================

// 文章分頁清單 (卡片牆)
export function getArticleList(data) {
  return request({
    url: '/AgencyExchange/getArticleList',
    method: 'post',
    data,
  })
}

// 文章內頁 (含內文＋留言)
export function getArticle(id) {
  return request({
    url: `/AgencyExchange/getArticle/${id}`,
    method: 'get',
  })
}

// 新增/編輯文章 (含封面 base64 上傳)
export function saveArticle(data) {
  return request({
    url: '/AgencyExchange/saveArticle',
    method: 'post',
    data,
  })
}

// 刪除文章 (軟刪除)
export function deleteArticle(data) {
  return request({
    url: '/AgencyExchange/deleteArticle',
    method: 'post',
    data,
  })
}

// ==================== 留言 ====================

// 新增留言
export function saveComment(data) {
  return request({
    url: '/AgencyExchange/saveComment',
    method: 'post',
    data,
  })
}

// 刪除留言 (軟刪除)
export function deleteComment(data) {
  return request({
    url: '/AgencyExchange/deleteComment',
    method: 'post',
    data,
  })
}

// ==================== 類別(標籤) ====================

// 類別清單 (下拉＋篩選 chip)
export function getTagList(data) {
  return request({
    url: '/AgencyExchange/getTagList',
    method: 'post',
    data,
  })
}

// 新增/編輯類別 (僅內部)
export function saveTag(data) {
  return request({
    url: '/AgencyExchange/saveTag',
    method: 'post',
    data,
  })
}

// 停用類別 (僅內部)
export function deleteTag(data) {
  return request({
    url: '/AgencyExchange/deleteTag',
    method: 'post',
    data,
  })
}

// ==================== 公告 BAR ====================

// 取公告 BAR 文字
export function getDisclaimer() {
  return request({
    url: '/AgencyExchange/getDisclaimer',
    method: 'get',
  })
}

// 儲存公告 BAR 文字 (僅內部)
export function saveDisclaimer(data) {
  return request({
    url: '/AgencyExchange/saveDisclaimer',
    method: 'post',
    data,
  })
}
